module.exports = __webpack_public_path__ + "static/daycool-logo-f838cbd7d2fa1d99a08bcf3e86dad5b0.png";